"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject8ToJSON = exports.InlineObject8FromJSONTyped = exports.InlineObject8FromJSON = void 0;
function InlineObject8FromJSON(json) {
    return InlineObject8FromJSONTyped(json, false);
}
exports.InlineObject8FromJSON = InlineObject8FromJSON;
function InlineObject8FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'messageId': json['messageId'],
        'channelId': json['channelId'],
        'botToken': json['botToken'],
    };
}
exports.InlineObject8FromJSONTyped = InlineObject8FromJSONTyped;
function InlineObject8ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'messageId': value.messageId,
        'channelId': value.channelId,
        'botToken': value.botToken,
    };
}
exports.InlineObject8ToJSON = InlineObject8ToJSON;
